/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_TitleInputs */

const tr_iletisim_title = /** @type {(inputs: Iletisim_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bize ulaşın`)
};

const en_iletisim_title = /** @type {(inputs: Iletisim_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get in touch`)
};

const de_iletisim_title = /** @type {(inputs: Iletisim_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktieren Sie uns`)
};

const ru_iletisim_title = /** @type {(inputs: Iletisim_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свяжитесь с нами`)
};

/**
* | output |
* | --- |
* | "Get in touch" |
*
* @param {Iletisim_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_title = /** @type {((inputs?: Iletisim_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_title(inputs)
	if (locale === "de") return de_iletisim_title(inputs)
	if (locale === "ru") return ru_iletisim_title(inputs)
	return tr_iletisim_title(inputs)
});